import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/theme-trp.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { advisorHubPage } from '../components/shared/Links';
import { PsBeaconButton } from '../components/shared/BeaconRegister';

const CustomerWebView = ({ planningGroup, isCustomerWebView, showAdvHubBtn }) => {
    const hasClientNames =
        planningGroup && planningGroup.clients && planningGroup.clients.length > 0;
    const getClientNames = hasClientNames
        ? planningGroup.clients.map((i) => i.name).join(', ')
        : 'N/A';

    return (
        isCustomerWebView && (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    borderTop: '2px solid #EA6C23',
                    color: 'white',
                    background: 'black',
                    marginBottom: '24px',
                }}>
                <Typography
                    type="caption" loose scale={300}
                    sx={{
                        backgroundColor: '#EA6C23',
                        height: showAdvHubBtn ? 'fit-content' : '75px',
                        width: 'fit-content',
                        paddingLeft: '12px',
                        paddingRight: '12px',
                        textAlign: 'center',
                    }}>
                    Customer Web View <br />
                    Household Member(s): {getClientNames}
                    {showAdvHubBtn && (
                        <Box>
                            <PsBeaconButton
                                id="to-advisor-hub"
                                onClick={() => window?.location?.replace(advisorHubPage)}
                                scale="mini">
                                Advisor Hub
                            </PsBeaconButton>
                        </Box>
                    )}
                </Typography>
            </Box>
        )
    );
};

export default CustomerWebView;
